import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineAccountLanguageGuard } from '../../guards/account/determineAccountLanguageGuard';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';

import type { AnyOfGuard } from '../../../types';

const baseGuardArray = [determineAccountLanguageGuard, determineI18nResourceGuard];

export const generateRouteServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  const additions = additionalGuards ?? [];

  return combineGuardsSerial([...baseGuardArray, ...additions]);
};
